import styled from 'styled-components';
import { getToastPosition, getToastVariantStyles } from '../utils/toastHelpers';

export const ToastContainer = styled.div`
  position: fixed;
  z-index: ${props => (props.theme.zIndex && props.theme.zIndex.toast) || 9999};
  display: flex;
  flex-direction: column;
  gap: 12px;
  pointer-events: none;
  
  /* Apply position styles */
  ${props => {
    const pos = getToastPosition(props.position);
    return Object.keys(pos).map(key => `${key}: ${pos[key]};`).join('\n  ');
  }}
`;

export const ToastWrapper = styled.div`
  pointer-events: auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: ${props => (props.theme.spacing && props.theme.spacing.md) || '16px'};
  border-radius: ${props => (props.theme.radii && props.theme.radii.md) || '8px'};
  box-shadow: ${props => (props.theme.shadows && props.theme.shadows.lg) || '0 10px 15px -3px rgba(0, 0, 0, 0.1)'};
  min-width: 300px;
  max-width: 450px;
  animation: slideIn 0.3s ease-out;

  ${props => {
    const styles = getToastVariantStyles(props.type, props.theme);
    return `
      background-color: ${styles.bg};
      color: ${styles.color};
    `;
  }}

  @keyframes slideIn {
    from { transform: translateY(-20px); opacity: 0; }
    to { transform: translateY(0); opacity: 1; }
  }
`;

export const ToastMessage = styled.div`
  flex: 1;
  font-family: ${props => (props.theme.typography && props.theme.typography.fontFamily && props.theme.typography.fontFamily.base) || 'sans-serif'};
  font-size: ${props => (props.theme.typography && props.theme.typography.fontSize && props.theme.typography.fontSize.sm) || '14px'};
  margin-right: 16px;
`;



// WEBPACK FOOTER //
// ./src/design-system/molecules/Toast/components/ToastStyles.js